var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sets",
    transform: "translate(1.000000, -9.000000)",
    stroke: "#7C8796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5652174,10.023824 C19.5652174,15.3055632 15.2817391,19.5890414 10,19.5890414 C4.71652174,19.5890414 0.434782609,15.3055632 0.434782609,10.023824 C0.434782609,4.74034579 4.71652174,0.458606658 10,0.458606658 C15.2817391,0.458606658 19.5652174,4.74034579 19.5652174,10.023824 L19.5652174,10.023824 Z",
    id: "Stroke-191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2173913,10.023824 L4.7826087,10.023824",
    id: "Stroke-192"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.45ff23eb.svg";
export { ForwardRef as ReactComponent };